import React from 'react';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getShortStrokeName } from '../../../services/utils/EventOrdering';
import { useFiltersCollapsed } from '../../hooks/useEventFilters';
import FilterChipGroup from './FilterChipGroup';
import GroupByToggle from './GroupByToggle';
/**
 * WHat the collapsed bar says in place of the chips, so a narrowed-down list never looks
 * like the full one. Only covers the stroke and distance chips - any `extaFilters` a page
 * supplies are its own to describe.
 */
const collapsedSummary = (selectedStrokes, selectedDistances) => {
    const active = [...selectedStrokes.map(getShortStrokeName), ...selectedDistances];
    if (active.length === 0)
        return 'Filters';
    if (active.length <= 3)
        return active.join(' • ');
    return `${active.length} filters active`;
};
/**
 * The stroke / distance / group-by control row shared by every event-listing page.
 *
 * Selection state stays with the caller: pages that persist it across tabs pass their
 * props straight through, and pages that own it locally pass their `useState` setter.
 */
const EventFilterBar = ({ strokes, selectedStrokes, onStrokesChange, distances, selectedDistances, onDistancesChange, groupBy, onGroupByChange, disabled, hideSingleOptions, extraFilters, children, }) => {
    const [collapsed, setCollapsed] = useFiltersCollapsed();
    return (React.createElement("div", { className: `filter-section${collapsed ? ' filters-collapsed' : ''}` },
        React.createElement("button", { type: "button", className: "btn-ghost section-toggle filter-collapse-toggle", onClick: () => setCollapsed(!collapsed), "aria-expanded": !collapsed, "aria-label": collapsed ? 'Show filters' : 'Hide filters' },
            React.createElement(FontAwesomeIcon, { icon: faFilter, className: "filter-collapse-icon" }),
            React.createElement("span", { className: "filter-collapse-summary" }, collapsedSummary(selectedStrokes, selectedDistances)),
            React.createElement(FontAwesomeIcon, { icon: faChevronDown, className: `chevron-icon${!collapsed ? ' expanded' : ''}` })),
        React.createElement(FilterChipGroup, { label: "Stroke", options: strokes, value: selectedStrokes, onChange: onStrokesChange, renderLabel: getShortStrokeName, disabled: disabled, hideWhenSingle: hideSingleOptions }),
        React.createElement(FilterChipGroup, { label: "Dist", options: distances, value: selectedDistances, onChange: onDistancesChange, disabled: disabled, hideWhenSingle: hideSingleOptions }),
        extraFilters,
        React.createElement(GroupByToggle, { value: groupBy, onChange: onGroupByChange, disabled: disabled }),
        children));
};
export default EventFilterBar;
